import { render } from "./PartnerFAQ.vue?vue&type=template&id=b36d0b9e"
import script from "./PartnerFAQ.vue?vue&type=script&lang=js"
export * from "./PartnerFAQ.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__